import { AuthContextProvider } from './AuthContext';
import { CoffeeContextProvider } from './CoffeeContext';

export default ({ children }) => {
  return (
    <AuthContextProvider>
      <CoffeeContextProvider>{children}</CoffeeContextProvider>
    </AuthContextProvider>
  );
};
